import { Injectable } from '@angular/core';
import { IDriftEntryDto } from '../../../models/features/schema-drift/IDriftEntryDto';
import { ITableDriftSummaryDto } from '../../../models/features/schema-drift/ITableDriftSummaryDto';

@Injectable({
  providedIn: 'root'
})
export class SchemaDriftService {

  constructor() { }

  public parseSchemaDrift(jsonData: any[]): IDriftEntryDto[] {
    const driftEntries: IDriftEntryDto[] = [];

    jsonData.forEach(record => {
      const date = record.Date;
      record.AuditMetrics.forEach((metric: string) => {
        // Match patterns like (tbl) TABLE_NAME, (col) COLUMN_NAME, (?) Added
        const match = metric.match(/\(tbl\)\s*(.+?),\s*\(col\)\s*(.*?),\s*\(\?\)\s*(\w+)/);
        if (match) {
          driftEntries.push({
            date,
            table: match[1].trim(),
            column: match[2].trim(),
            action: match[3].trim()
          });
        }
      });
    });

    return driftEntries;
  }

  public summarizeByTable(entries: IDriftEntryDto[]): ITableDriftSummaryDto[] {
    const summaryMap = new Map<string, ITableDriftSummaryDto>();

    for (const entry of entries) {
      const key = entry.table;
      if (!summaryMap.has(key)) {
        summaryMap.set(key, { table: key, added: 0, archived: 0, removed: 0, totalChanges: 0, lastChangeDate: entry.date });
      }
      const s = summaryMap.get(key)!;
      if (entry.action === 'Added') s.added++;
      else if (entry.action === 'Archived') s.archived++;
      else if (entry.action === 'Removed') s.removed++;
      s.totalChanges++;
      s.lastChangeDate = entry.date;
    }

    return Array.from(summaryMap.values()).sort((a, b) => b.totalChanges - a.totalChanges);
  }

  public computeStabilityIndex(summaries: ITableDriftSummaryDto[], totalTables: number): number {
    const stableTables = totalTables - summaries.length;
    return Math.round((stableTables / totalTables) * 100);
  }

  public exportToCSV(data: ITableDriftSummaryDto[]): string {
    const header = ['Table', 'Added', 'Archived', 'Removed', 'Total Changes', 'Last Change Date'];
    const rows = data.map(x => `${x.table},${x.added},${x.archived},${x.removed},${x.totalChanges},${x.lastChangeDate}`);
    return [header.join(','), ...rows].join('\n');
  }
}
